export enum RiskTagEnum {
    Low = 1,
    Moderate = 2,
    High = 3,
    Extreme = 4,
}

export const RiskTagEnumToString = ((option: RiskTagEnum) => {
    switch (option) {
        case RiskTagEnum.Low:
            return 'Low';
        case RiskTagEnum.Moderate:
            return 'Moderate';
        case RiskTagEnum.High:
            return 'High';
        case RiskTagEnum.Extreme:
            return 'Extreme';
        default: 'NA'
    }
});